import { CalendarType } from '@/components/calendar/types';
import { Weekday } from '@/utils/date/types';
import { ArrowDirection } from './types';

export const ZERO_BASED_WEEKDAYS = [
    Weekday.Monday,
    Weekday.Tuesday,
    Weekday.Wednesday,
    Weekday.Thursday,
    Weekday.Friday,
    Weekday.Saturday,
    Weekday.Sunday_Zero,
];

export const WEEKDAYS = [
    Weekday.Monday,
    Weekday.Tuesday,
    Weekday.Wednesday,
    Weekday.Thursday,
    Weekday.Friday,
    Weekday.Saturday,
    Weekday.Sunday,
];

export const ARROW_OPTIONS = [
    {
        id: ArrowDirection.Previous,
        value: '‹',
    },
    {
        id: ArrowDirection.Next,
        value: '›',
    },
]

export const TYPE_OPTIONS = [
    
    {
        id: CalendarType.Day,
        value: 'День',
    },
    {
        id: CalendarType.Week,
        value: 'Неделя',
    },
    {
        id: CalendarType.Month,
        value: 'Месяц',
    }
];